module.exports = __webpack_public_path__ + "static/media/135U12_Bedroom2.d66217e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U12_Bedroom2.jpg
// module id = 549
// module chunks = 0